import React, { useState, useEffect } from 'react';
import { Row, Col, Form } from 'react-bootstrap';

const CustomTimePicker = ({
    value,
    onChange,
    controlId,
    name,
    wrapperClass,
    disabled = false
}) => {
    const [hour, setHour] = useState('');
    const [minute, setMinute] = useState('');
    const [ampm, setAmPm] = useState('');

    // Convert 24-hour value (like "13:45") to 12-hour components
    useEffect(() => {
        if (value && value.includes(':')) {
            const [h24, m] = value.split(':');
            const h = parseInt(h24, 10);
            const isPM = h >= 12;
            const h12 = h % 12 === 0 ? 12 : h % 12;
            setHour(String(h12).padStart(2, '0'));
            setMinute(m);
            setAmPm(isPM ? 'PM' : 'AM');
        } else {
            setHour('');
            setMinute('');
            setAmPm('');
        }
    }, [value]);

    // Convert to 24-hour format for backend/state
    const to24HourFormat = (h, m, a) => {
        let hr = parseInt(h, 10);
        if (a === 'PM' && hr !== 12) hr += 12;
        if (a === 'AM' && hr === 12) hr = 0;
        return `${String(hr).padStart(2, '0')}:${m}`;
    };

    const handleChange = (h, m, a) => {
        const time24 = to24HourFormat(h, m, a);
        onChange && onChange({
            target: {
                name: name,
                value: time24
            }
        });
    };

    const handleHourChange = (e) => {
        const val = e.target.value;
        setHour(val);
        handleChange(val, minute, ampm);
    };

    const handleMinuteChange = (e) => {
        const val = e.target.value;
        setMinute(val);
        handleChange(hour, val, ampm);
    };

    const handleAmPmChange = (e) => {
        const val = e.target.value;
        setAmPm(val);
        handleChange(hour, minute, val);
    };

    const hours = Array.from({ length: 12 }, (_, i) => String(i + 1).padStart(2, '0'));
    const minutes = ['00', '15', '30', '45'];

    return (
        <Form.Group controlId={controlId} className={wrapperClass}>
            <Row className="g-1">
                <Col className="time-picker-col">
                    <Form.Select disabled={disabled} value={hour} onChange={handleHourChange}>
                        <option value="" disabled>HH</option>
                        {hours.map(h => <option key={h} value={h}>{h}</option>)}
                    </Form.Select>
                </Col>
                <Col className="time-picker-col">
                    <Form.Select disabled={disabled} value={minute} onChange={handleMinuteChange}>
                        <option value="" disabled>MM</option>
                        {minutes.map(m => <option key={m} value={m}>{m}</option>)}
                    </Form.Select>
                </Col>
                <Col className="time-picker-col">
                    <Form.Select disabled={disabled} value={ampm} onChange={handleAmPmChange}>
                        <option value="" disabled>AM/PM</option>
                        <option value="AM">AM</option>
                        <option value="PM">PM</option>
                    </Form.Select>
                </Col>
            </Row>
        </Form.Group>
    );
};

export default CustomTimePicker;